import { defineStore } from 'pinia';
export interface LayoutState {
  extendedSidebar: boolean;
  viewerSidebarExpanded: boolean;
  viewerSidebarActive: boolean;
  theaterSidebarCollapsed: boolean;
  getCtaVisible: boolean;
  backButtonVisible: boolean;
}

export const useLayoutStore = defineStore('layoutStore', {
  state: () =>
    ({
      extendedSidebar: true,
      viewerSidebarExpanded: false,
      viewerSidebarActive: false,
      theaterSidebarCollapsed: false,
      getCtaVisible: true,
      backButtonVisible: false,
    }) as LayoutState,
  actions: {
    toggleExtendedSidebar() {
      if (this.viewerSidebarActive) {
        this.viewerSidebarExpanded = !this.viewerSidebarExpanded;
        return;
      }

      this.extendedSidebar = !this.extendedSidebar;
    },
    hideSidebar() {
      if (this.viewerSidebarActive) {
        this.viewerSidebarExpanded = false;
        return;
      }

      this.extendedSidebar = false;
    },
    setViewerSidebarActive(isActive: boolean) {
      this.viewerSidebarActive = isActive;
    },
    setTheaterSidebarCollapsed(isCollapsed: boolean) {
      this.theaterSidebarCollapsed = isCollapsed;
    },
    showCta() {
      this.getCtaVisible = true;
    },
    hideCta() {
      this.getCtaVisible = false;
    },
    showBackButton() {
      this.backButtonVisible = true;
    },
    hideBackButton() {
      this.backButtonVisible = false;
    },
  },
  getters: {
    isSidebarExpanded: state => (state.viewerSidebarActive ? state.viewerSidebarExpanded : state.extendedSidebar) && !state.theaterSidebarCollapsed,
    isCtaVisible: state => state.getCtaVisible,
    isBackButtonVisible: state => state.backButtonVisible,
  },
  persist: {
    paths: ['extendedSidebar', 'viewerSidebarExpanded'],
  },
});
